"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CBValidator = void 0;
const config_1 = require("../../config");
const CountryValidator_class_1 = require("../CountryValidator.class");
const util_1 = require("../../util");
const lodash_1 = require("lodash");
class CBValidator extends CountryValidator_class_1.CountryValidator {
    isValidPostalCode(value, opts) {
        this.throwErrorIfChannelInvalidOrMissing(opts);
        return CBValidator.postalCodeRegex[opts.forceChannel].test(value);
    }
    isAustriaTINChecksumValid(code) {
        if (typeof code !== 'string') {
            code = String(code);
        }
        code = code.replace(/[^0-9.]+/g, '');
        if ((code.length !== CBValidator.AUSTRIA_TIN_LENGTH) || /0{9}$/.test(code)) {
            return false;
        }
        const checkSum = parseInt(code.slice(-1), 10);
        const calculatedSum = code
            .slice(0, -1)
            .split('')
            .reduce((acc, item, index) => {
            return acc.concat(parseInt(item, 10) * ([1, 2, 1, 2, 1, 2, 1, 2][index] ?? 0));
        }, [])
            .map((item) => {
            return item > CBValidator.AUSTRIA_TIN_LENGTH ? (0, util_1.sumDigits)(item) : item;
        })
            .reduce((result, value) => result + value, 0);
        return checkSum === (0, util_1.getLastDigit)(100 - calculatedSum);
    }
    isGermanTINValid(value) {
        if (!(0, lodash_1.isString)(value))
            value = String(value);
        if (value.length !== 11 || value[0] === '0' || !/^\d+$/.test(value))
            return false;
        const body = value.slice(0, -1).split('').map((x) => parseInt(x, 10));
        const tail = parseInt(value.slice(-1), 10);
        const cMap = (0, util_1.countDigits)(value.slice(0, 10)); // digits count map
        const rMap = (0, util_1.countDigits)(Object.values(cMap).join('')); // digits repeats map
        const cMapValues = Object.values(cMap);
        const rMapValues = Object.values(rMap);
        return [
            body.reduce((x, n) => ((0, util_1.replaceIf)((n + x) % 10, 0, 10) * 2) % 11, 10),
            body.reduce((x, n) => ((0, util_1.replaceIf)((n + x) % 10, 0, 10) * 2) % 11, 0)
        ].map((n) => 11 - n === 10 ? 0 : 11 - n).includes(tail) && ((rMapValues.filter((n) => n === 0).length === 1 && [0, 1].includes(rMapValues.filter((n) => n === 0).length)) ||
            (cMapValues.filter((n) => n === 3).length <= 1 && cMapValues.filter((n) => n === 2).length <= 1)) && cMapValues.filter((n) => n > 3).length === 0;
    }
    /*
      * For Netherlands, the TIN always has 9 digits: N1, N2, N3, N4, N5, N6, N7, N8, N9
      * N9 is a check digit.
      * Algorithm for check digit:
      * ((N1*9) + (N2*8) + (N3*7) + (N4*6) + (N5*5) + (N6*4) + (N7*3) + (N8*2)) modulo 11
      * Check digit (N9) = remainder from above algorithm
      * If remainder = 10, the TIN is not valid
    */
    isValidTaxIdNumber(value, opts) {
        this.throwErrorIfChannelInvalidOrMissing(opts);
        let validationResult = false;
        value = value.toString();
        switch (opts.forceChannel) {
            case config_1.CountryChannel.DE:
                validationResult = this.isGermanTINValid(value);
                break;
            case config_1.CountryChannel.AT:
                validationResult = /^[0-9]{2}-[0-9]{3}\/[0-9]{4}$/.test(value) && this.isAustriaTINChecksumValid(value);
                break;
            case config_1.CountryChannel.NL:
                if (value.length === 9) {
                    let sum = 0;
                    for (let i = 0; i < 8; i++) {
                        sum += parseInt(value[i]) * (9 - i);
                    }
                    const remainder = sum % 11;
                    validationResult = remainder === Number(value.charAt(8)) && remainder !== 10;
                }
                break;
        }
        return validationResult;
    }
    throwErrorIfChannelInvalidOrMissing(opts) {
        if (!opts.forceChannel || ![config_1.CountryChannel.DE, config_1.CountryChannel.AT, config_1.CountryChannel.NL].includes(opts.forceChannel)) {
            throw new Error('Wrong channel or channel missing!');
        }
    }
}
exports.CBValidator = CBValidator;
CBValidator.AUSTRIA_TIN_LENGTH = 9;
CBValidator.postalCodeRegex = {
    [config_1.CountryChannel.AT]: /^\d{4}$/,
    [config_1.CountryChannel.DE]: /^\d{5}$/,
    [config_1.CountryChannel.NL]: /^[1-9]{1}\d{3}[A-Za-z]{2}$/
};
